<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span>CONTENTS</span></p>
<p class="toc-text"><span><a href="#/xhtml/frontmatter03"><i>Prologue</i></a></span></p>
<p class="toc-text1"><span><a href="#/xhtml/chapter001"><i>1. Calamity</i></a></span></p>
<p class="toc-text"><span><a href="#/xhtml/chapter002"><i>2. The Wanna-be</i></a></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter003" title="Link target outside of Sample"><i>3. The Big Show</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter004" title="Link target outside of Sample"><i>4. Intuition</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter005" title="Link target outside of Sample"><i>5. Pool of Fire</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter006" title="Link target outside of Sample"><i>6. The Fingerprint</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter007" title="Link target outside of Sample"><i>7. Bird Dog</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter008" title="Link target outside of Sample"><i>8. Points of Origin</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter009" title="Link target outside of Sample"><i>9. The Prisoner</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter010" title="Link target outside of Sample"><i>10. Fire Lover</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter011" title="Link target outside of Sample"><i>11. Conspiracy</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter012" title="Link target outside of Sample"><i>12. Errors</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter013" title="Link target outside of Sample"><i>13. Verdict</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter014" title="Link target outside of Sample"><i>14. Strange Fish</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter015" title="Link target outside of Sample"><i>15. Mary Duggan</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter016" title="Link target outside of Sample"><i>16. The Fire Monster</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter017" title="Link target outside of Sample"><i>17. Redactions</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter018" title="Link target outside of Sample"><i>18. Uncharged Acts</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter019" title="Link target outside of Sample"><i>19. The Manuscript</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter020" title="Link target outside of Sample"><i>20. Death House</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter021" title="Link target outside of Sample"><i>21. Survivors</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter022" title="Link target outside of Sample"><i>22. The Debate</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter023" title="Link target outside of Sample"><i>23. The Quest</i></span></span></p>
<p class="toc-text1"><span><span href="#/xhtml/endmatter001" title="Link target outside of Sample"><i>Epilogue</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/endmatter002" title="Link target outside of Sample"><i>Acknowledgments</i></span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?b3ebb34c